import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  GROUP_TYPE_URL,
  RESOLVER_GROUP_URL,
  TICKET_CATEGORIES_URL,
  USERS_URL,
} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import { useAlert } from "./../../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function GroupsDialog({ groupId, selectedGroupName, callGroups, isEdit }) {
  const [open, setOpen] = React.useState(false);
  const [groupName, setGroupName] = useState("");
  const [desc, setDesc] = useState("");

  const [groupType, setGroupType] = useState();
  const [groupTypes, setGroupTypes] = useState([]);

  const [owner, setOwner] = useState();
  const [owners, setOwners] = useState([]);

  const [category, setCategory] = useState();
  const [categories, setCategories] = useState([]);
  const showAlert = useAlert();

  useEffect(() => {
    getCategories();
    getGroupTypes();
    getUsers();
  }, []);

  const handleClickOpen = () => {
    if (isEdit) {
      getGroup();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleGroupNameChange = (event) => {
    setGroupName(event.target.value);
  };

  const handleGroupTypeChange = (event) => {
    setGroupType(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const handleOwnerChange = (event) => {
    setOwner(event.target.value);
  };

  const getGroupTypes = () => {
    AxiosInstance.get(GROUP_TYPE_URL).then((response) =>
      setGroupTypes(response.data)
    );
  };

  const getCategories = () => {
    AxiosInstance.get(TICKET_CATEGORIES_URL).then((response) =>
      setCategories(response.data.data)
    );
  };

  const getUsers = () => {
    AxiosInstance.get(USERS_URL).then((response) => setOwners(response.data.data));
  };

  const getGroup = async () => {
    await AxiosInstance.get(`${RESOLVER_GROUP_URL}/${groupId}`).then((response) => {
      var groupData = response.data.data;
      //setGroup(groupData);
      setGroupName(groupData.name);
      setOwner(groupData.owner ?.id);
      setCategory(groupData ?.ticketCategory ?.id);
      setGroupType(groupData ?.groupType ?.id);
      setDesc(groupData.description);
      setOpen(true);
    });
  };

  const handleSave = (name) => {
    const payload = {};
    payload.name = groupName;
    payload.owner = { id: owner };
    payload.description = desc;
    payload.groupType = { id: groupType };
    payload.ticketCategory = { id: category };

    if (isEdit) {
      updateGroup(payload);
    } else {
      saveGroup(payload);
    }
  };

  const saveGroup = async (payload) => {
    await AxiosInstance.post(RESOLVER_GROUP_URL, payload)
      .then((response) => {
        showAlert("Resolver Group saved successfully!", "success");
        callGroups();
      })
      .catch((error) => {
        showAlert("Resolver Group creation failed!", "error");
        console.error(error);
      });
  };


  const updateGroup = async (payload) => {
    await AxiosInstance.put(`${RESOLVER_GROUP_URL}/${groupId}`, payload)
      .then((response) => {
        showAlert("Resolver Group updated successfully!", "success");
        callGroups();
      })
      .catch((error) => {
        showAlert("Resolver Group updation failed!", "error");
        console.error(error);
      });
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        {groupId === 0 ? (
          <>
          {/* <Button
              variant="outlined"
              onClick={handleClickOpen}
              style={{ float: "right", margin: "5px" }}
            >
              Add Resolver Group
            </Button> */}
          < Tooltip
              title= "Add Resolver Group"
              onClick={handleClickOpen}
        style={{ cursor: "pointer", margin: "2px", float: "right" }}
        >
              <IconButton>
          <AddTaskIcon color="primary" />
        </IconButton>
            </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{selectedGroupName}</Link>
  )
}

<Dialog
  open={open}
  onClose={handleClose}
  PaperProps={{
    component: "form",
    onSubmit: (event) => {
      event.preventDefault();
      const formData = new FormData(event.currentTarget);
      const formJson = Object.fromEntries(formData.entries());
      const name = formJson.name;
      console.log(name);
      handleSave(name);
      handleClose();
    },
  }}
>
  <DialogTitle>
    {groupId === 0 ? "Add Resolver Group" : "Edit Resolver Group"}
  </DialogTitle>
  <DialogContent>
    <Box
      component="form"
      sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
      noValidate
      autoComplete="off"
    >
      <TextField
        autoFocus
        required
        margin="dense"
        id="rg"
        name="name"
        label="Group Name"
        type="text"
        fullWidth
        variant="outlined"
        value={groupName}
        onChange={handleGroupNameChange}
      />

      <Grid container spacing={2} columns={16}>
        <Grid size={8}>
          <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">
              Category
                    </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={category}
              onChange={handleCategoryChange}
              label="Category"
            >
              <MenuItem value="">
                {" "}
                <em>None </em>{" "}
              </MenuItem>
              {categories.map((cat) => (
                <MenuItem value={cat.id}>{cat.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={8}>
          <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">
              Group Type
                    </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={groupType}
              onChange={handleGroupTypeChange}
              label="Group Type"
            >
              <MenuItem value="">
                {" "}
                <em>None </em>{" "}
              </MenuItem>
              {groupTypes.map((gt) => (
                <MenuItem value={gt.id}>{gt.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2} columns={16}>
        <Grid size={8}>
          <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">
              Owner
                    </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={owner}
              onChange={handleOwnerChange}
              label="Owner"
            >
              <MenuItem value="">
                {" "}
                <em>None </em>{" "}
              </MenuItem>
              {owners.map((ow) => (
                <MenuItem value={ow.id}>{ow.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <TextField
        autoFocus
        id="outlined-multiline-static"
        name="description"
        label="Description"
        placeholder="Enter Description"
        fullWidth
        multiline
        rows={4}
        cols={10}
        value={desc}
        onChange={handleDescriptionChange}
      />
      <br />
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleClose}>Cancel</Button>
    <Button type="submit">Add </Button>
  </DialogActions>
</Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default GroupsDialog;
